import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Grants from "./pages/Grants";
import HealthPrograms from "./pages/Health_program";
import SuccessPage from "./pages/Successpage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HealthProgramStepper from "./pages/SelectionPage";
import React, { useEffect } from "react";
import HealthProgram_150 from "./pages/Health_program_150";
import Form from "./pages/Form";
import Assessment from "./Componenets/VentureRev";
import GrantForm from "./pages/GrantForm";
import DemoForm from "./pages/DemoForm";

// ProtectedRoute component to check local storage before rendering HealthPrograms
const ProtectedRoute = ({ element: Element, ...rest }) => {
  const employees = localStorage.getItem("employees");
  const program = localStorage.getItem("program");

  if (employees && program) {
    return <Element {...rest} />;
  } else {
    return <Navigate to="/" />;
  }
};

const ProtectedRoute2 = ({ element: Element, ...rest }) => {
  const formData = localStorage.getItem("formData");
  console.log(JSON.parse(formData), "form data");
  if (formData) {
    return <Element {...rest} />;
  } else {
    return <Navigate to="/" />;
  }
};

// Component to scroll to the top on route change
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop /> {/* Add the ScrollToTop component here */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/grants" element={<GrantForm />} />
          <Route path="/DemoForm" element={<DemoForm />} />
          {/* <Route path="/grants" element={<Form />} /> */}
          {/* <Route
            path="/Health-Program"
            element={<ProtectedRoute element={HealthPrograms} />}
          /> */}
          {/* <Route path="/Success" element={<ProtectedRoute2 element={SuccessPage} />} /> */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/assessment" element={<Assessment />} />

          {/* <Route path='/Health-Program-150' element={<HealthProgram_150 />} /> */}

          {/* <Route path='/Pre-Qualifier' element={<HealthProgramStepper />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
